import type { ReactElement } from 'react'

import type { MockedResponse } from '@apollo/client/testing'
import { render } from '@testing-library/react'
import { IntlProvider } from 'react-intl'
import { MemoryRouter } from 'react-router-dom'

import { Alert, theme, themeClarity, ThemeProvider } from '@acre/design-system'
import type { Flags } from '@acre/utils'
import {
  applyScoreBranding,
  ErrorProvider,
  FlagProvider,
  flagsAllEnabled,
  flattenMessages,
  getMessages,
  Locales,
} from '@acre/utils'

import { messagesIntroducers as messages } from '../../intl/messagesIntroducers'
import MockedProvider from './MockedProvider'

const flattenedMessages = flattenMessages(getMessages(messages, Locales.GB))

export default (tree: ReactElement, mocks?: MockedResponse<Record<string, any>>[], flags?: Flags) => {
  const children = mocks ? <MockedProvider mocks={mocks}>{tree}</MockedProvider> : tree
  const resolvedFlags = flags || flagsAllEnabled
  const providerMessages = resolvedFlags.feature?.score_rebrand
    ? applyScoreBranding(flattenedMessages)
    : flattenedMessages

  return render(
    <FlagProvider value={resolvedFlags}>
      <IntlProvider locale={Locales.GB} messages={providerMessages}>
        <ThemeProvider theme={resolvedFlags.feature?.score_font ? themeClarity : theme}>
          <ErrorProvider alertSlot={Alert}>
            <MemoryRouter>{children}</MemoryRouter>
          </ErrorProvider>
        </ThemeProvider>
      </IntlProvider>
    </FlagProvider>,
  )
}
